const mockRepos = [
  {
    id: 65004971,
    node_id: "MDEwOlJlcG9zaXRvcnk2NTAwNDk3MQ==",
    name: "angular-2-playlist",
    full_name: "iamshaunjp/angular-2-playlist",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/angular-2-playlist",
    description:
      "Assets and files to follow along with The Net Ninja Angular 2 playlist on YouTube",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/angular-2-playlist",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/angular-2-playlist/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/angular-2-playlist/deployments",
    created_at: "2016-08-05T09:05:10Z",
    updated_at: "2020-11-12T15:23:01Z",
    pushed_at: "2016-08-05T09:05:18Z",
    git_url: "git://github.com/iamshaunjp/angular-2-playlist.git",
    ssh_url: "git@github.com:iamshaunjp/angular-2-playlist.git",
    clone_url: "https://github.com/iamshaunjp/angular-2-playlist.git",
    svn_url: "https://github.com/iamshaunjp/angular-2-playlist",
    homepage: null,
    size: 6,
    stargazers_count: 32,
    watchers_count: 32,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 48,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: null,
    forks: 48,
    open_issues: 2,
    watchers: 32,
    default_branch: "master",
  },
  {
    id: 51767540,
    node_id: "MDEwOlJlcG9zaXRvcnk1MTc2NzU0MA==",
    name: "angular-js-playlist",
    full_name: "iamshaunjp/angular-js-playlist",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/angular-js-playlist",
    description: "Core files for The Net Ninja AngularJS YouTube playlist",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/angular-js-playlist",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/angular-js-playlist/deployments",
    created_at: "2016-02-15T16:11:45Z",
    updated_at: "2021-04-30T16:45:18Z",
    pushed_at: "2016-02-16T07:53:08Z",
    git_url: "git://github.com/iamshaunjp/angular-js-playlist.git",
    ssh_url: "git@github.com:iamshaunjp/angular-js-playlist.git",
    clone_url: "https://github.com/iamshaunjp/angular-js-playlist.git",
    svn_url: "https://github.com/iamshaunjp/angular-js-playlist",
    homepage: null,
    size: 225,
    stargazers_count: 46,
    watchers_count: 46,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 118,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 118,
    open_issues: 0,
    watchers: 46,
    default_branch: "master",
  },
  {
    id: 79713965,
    node_id: "MDEwOlJlcG9zaXRvcnk3OTcxMzk2NQ==",
    name: "bootstrap-4-playlist",
    full_name: "iamshaunjp/bootstrap-4-playlist",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/bootstrap-4-playlist",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/bootstrap-4-playlist/deployments",
    created_at: "2017-01-22T11:34:35Z",
    updated_at: "2021-05-11T01:07:52Z",
    pushed_at: "2018-01-19T05:02:44Z",
    git_url: "git://github.com/iamshaunjp/bootstrap-4-playlist.git",
    ssh_url: "git@github.com:iamshaunjp/bootstrap-4-playlist.git",
    clone_url: "https://github.com/iamshaunjp/bootstrap-4-playlist.git",
    svn_url: "https://github.com/iamshaunjp/bootstrap-4-playlist",
    homepage: null,
    size: 113,
    stargazers_count: 65,
    watchers_count: 65,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 92,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 3,
    license: null,
    forks: 92,
    open_issues: 3,
    watchers: 65,
    default_branch: "master",
  },
  {
    id: 294427088,
    node_id: "MDEwOlJlcG9zaXRvcnkyOTQ0MjcwODg=",
    name: "bulma-ui-build",
    full_name: "iamshaunjp/bulma-ui-build",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/bulma-ui-build",
    description:
      "Course files for the Bulma product page UI design tutorial on the Net Ninja YouTube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/bulma-ui-build",
    forks_url: "https://api.github.com/repos/iamshaunjp/bulma-ui-build/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/iamshaunjp/bulma-ui-build/teams",
    hooks_url: "https://api.github.com/repos/iamshaunjp/bulma-ui-build/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/issues/events{/number}",
    events_url: "https://api.github.com/repos/iamshaunjp/bulma-ui-build/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/bulma-ui-build/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/iamshaunjp/bulma-ui-build/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/bulma-ui-build/deployments",
    created_at: "2020-09-10T14:03:27Z",
    updated_at: "2021-05-14T05:01:15Z",
    pushed_at: "2020-09-11T11:16:01Z",
    git_url: "git://github.com/iamshaunjp/bulma-ui-build.git",
    ssh_url: "git@github.com:iamshaunjp/bulma-ui-build.git",
    clone_url: "https://github.com/iamshaunjp/bulma-ui-build.git",
    svn_url: "https://github.com/iamshaunjp/bulma-ui-build",
    homepage: null,
    size: 1973,
    stargazers_count: 34,
    watchers_count: 34,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 20,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 20,
    open_issues: 0,
    watchers: 34,
    default_branch: "master",
  },
  {
    id: 320650154,
    node_id: "MDEwOlJlcG9zaXRvcnkzMjA2NTAxNTQ=",
    name: "Complete-React-Tutorial",
    full_name: "iamshaunjp/Complete-React-Tutorial",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/Complete-React-Tutorial",
    description:
      "All course files for the Complete React Tutorial on the Net Ninja YouTube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/Complete-React-Tutorial/deployments",
    created_at: "2020-12-11T18:15:05Z",
    updated_at: "2021-05-20T10:04:17Z",
    pushed_at: "2021-03-28T23:37:05Z",
    git_url: "git://github.com/iamshaunjp/Complete-React-Tutorial.git",
    ssh_url: "git@github.com:iamshaunjp/Complete-React-Tutorial.git",
    clone_url: "https://github.com/iamshaunjp/Complete-React-Tutorial.git",
    svn_url: "https://github.com/iamshaunjp/Complete-React-Tutorial",
    homepage: null,
    size: 247,
    stargazers_count: 325,
    watchers_count: 325,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 290,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 2,
    license: null,
    forks: 290,
    open_issues: 2,
    watchers: 325,
    default_branch: "main",
  },
  {
    id: 55680193,
    node_id: "MDEwOlJlcG9zaXRvcnk1NTY4MDE5Mw==",
    name: "css-animations-playlist",
    full_name: "iamshaunjp/css-animations-playlist",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/css-animations-playlist",
    description:
      "All bas project files for The Net Ninja CSS Animations tutorial playlist on YouTube.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/css-animations-playlist",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/css-animations-playlist/deployments",
    created_at: "2016-04-07T09:07:00Z",
    updated_at: "2021-05-08T17:58:33Z",
    pushed_at: "2020-06-30T12:39:48Z",
    git_url: "git://github.com/iamshaunjp/css-animations-playlist.git",
    ssh_url: "git@github.com:iamshaunjp/css-animations-playlist.git",
    clone_url: "https://github.com/iamshaunjp/css-animations-playlist.git",
    svn_url: "https://github.com/iamshaunjp/css-animations-playlist",
    homepage: null,
    size: 37,
    stargazers_count: 156,
    watchers_count: 156,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 185,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 6,
    license: null,
    forks: 185,
    open_issues: 6,
    watchers: 156,
    default_branch: "master",
  },
  {
    id: 321415461,
    node_id: "MDEwOlJlcG9zaXRvcnkzMjE0MTU0NjE=",
    name: "CSS-Christmas-Present",
    full_name: "iamshaunjp/CSS-Christmas-Present",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/CSS-Christmas-Present",
    description:
      "Course files for the CSS Christmas Present promo animation tutorial on the Net Ninja YouTube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Christmas-Present/deployments",
    created_at: "2020-12-14T16:59:18Z",
    updated_at: "2021-04-21T05:05:53Z",
    pushed_at: "2021-01-01T14:36:43Z",
    git_url: "git://github.com/iamshaunjp/CSS-Christmas-Present.git",
    ssh_url: "git@github.com:iamshaunjp/CSS-Christmas-Present.git",
    clone_url: "https://github.com/iamshaunjp/CSS-Christmas-Present.git",
    svn_url: "https://github.com/iamshaunjp/CSS-Christmas-Present",
    homepage: null,
    size: 1,
    stargazers_count: 24,
    watchers_count: 24,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 12,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    forks: 12,
    open_issues: 1,
    watchers: 24,
    default_branch: "main",
  },
  {
    id: 53578856,
    node_id: "MDEwOlJlcG9zaXRvcnk1MzU3ODg1Ng==",
    name: "css-flexbox-playlist",
    full_name: "iamshaunjp/css-flexbox-playlist",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/css-flexbox-playlist",
    description:
      "Base HTML & CSS files, plus example files, for TheNetNinja CSS Flexbox Playlist on YouTube.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/css-flexbox-playlist/deployments",
    created_at: "2016-03-10T11:21:50Z",
    updated_at: "2021-05-20T06:51:21Z",
    pushed_at: "2021-02-04T06:23:12Z",
    git_url: "git://github.com/iamshaunjp/css-flexbox-playlist.git",
    ssh_url: "git@github.com:iamshaunjp/css-flexbox-playlist.git",
    clone_url: "https://github.com/iamshaunjp/css-flexbox-playlist.git",
    svn_url: "https://github.com/iamshaunjp/css-flexbox-playlist",
    homepage: null,
    size: 12,
    stargazers_count: 120,
    watchers_count: 120,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 139,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 139,
    open_issues: 0,
    watchers: 120,
    default_branch: "master",
  },
  {
    id: 39383854,
    node_id: "MDEwOlJlcG9zaXRvcnkzOTM4Mzg1NA==",
    name: "CSS-for-Beginners---Bikes-Website",
    full_name: "iamshaunjp/CSS-for-Beginners---Bikes-Website",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/CSS-for-Beginners---Bikes-Website",
    description: "All files for the CSS for beginners tutorial series.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/CSS-for-Beginners---Bikes-Website/deployments",
    created_at: "2015-07-20T12:58:35Z",
    updated_at: "2021-05-13T19:32:51Z",
    pushed_at: "2020-10-01T12:38:03Z",
    git_url:
      "git://github.com/iamshaunjp/CSS-for-Beginners---Bikes-Website.git",
    ssh_url: "git@github.com:iamshaunjp/CSS-for-Beginners---Bikes-Website.git",
    clone_url:
      "https://github.com/iamshaunjp/CSS-for-Beginners---Bikes-Website.git",
    svn_url: "https://github.com/iamshaunjp/CSS-for-Beginners---Bikes-Website",
    homepage: null,
    size: 192,
    stargazers_count: 23,
    watchers_count: 23,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 27,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 4,
    license: null,
    forks: 27,
    open_issues: 4,
    watchers: 23,
    default_branch: "master",
  },
  {
    id: 103415276,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDM0MTUyNzY=",
    name: "css-grid-playlist",
    full_name: "iamshaunjp/css-grid-playlist",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/css-grid-playlist",
    description:
      "Course files for the CSS Grid playlist on The Net Ninja YouTube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/css-grid-playlist",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/css-grid-playlist/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/css-grid-playlist/deployments",
    created_at: "2017-09-13T15:12:07Z",
    updated_at: "2021-05-17T10:26:29Z",
    pushed_at: "2020-06-18T09:01:06Z",
    git_url: "git://github.com/iamshaunjp/css-grid-playlist.git",
    ssh_url: "git@github.com:iamshaunjp/css-grid-playlist.git",
    clone_url: "https://github.com/iamshaunjp/css-grid-playlist.git",
    svn_url: "https://github.com/iamshaunjp/css-grid-playlist",
    homepage: null,
    size: 7,
    stargazers_count: 149,
    watchers_count: 149,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 158,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    forks: 158,
    open_issues: 1,
    watchers: 149,
    default_branch: "master",
  },
  {
    id: 305367688,
    node_id: "MDEwOlJlcG9zaXRvcnkzMDUzNjc2ODg=",
    name: "css-loaders-tutorial",
    full_name: "iamshaunjp/css-loaders-tutorial",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/css-loaders-tutorial",
    description:
      "All course files for the CSS Loaders tutorial on the Net Ninja YouTube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/css-loaders-tutorial/deployments",
    created_at: "2020-10-19T11:54:44Z",
    updated_at: "2021-04-22T22:56:50Z",
    pushed_at: "2020-11-14T10:49:30Z",
    git_url: "git://github.com/iamshaunjp/css-loaders-tutorial.git",
    ssh_url: "git@github.com:iamshaunjp/css-loaders-tutorial.git",
    clone_url: "https://github.com/iamshaunjp/css-loaders-tutorial.git",
    svn_url: "https://github.com/iamshaunjp/css-loaders-tutorial",
    homepage: null,
    size: 4,
    stargazers_count: 29,
    watchers_count: 29,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 9,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    forks: 9,
    open_issues: 1,
    watchers: 29,
    default_branch: "starter-files",
  },
  {
    id: 75611312,
    node_id: "MDEwOlJlcG9zaXRvcnk3NTYxMTMxMg==",
    name: "CSS-Tips-and-Tricks",
    full_name: "iamshaunjp/CSS-Tips-and-Tricks",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/CSS-Tips-and-Tricks",
    description:
      "A repo for the 'CSS Tips & Tricks' playlist on The Net Ninja YouTube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Tips-and-Tricks/deployments",
    created_at: "2016-12-05T09:52:01Z",
    updated_at: "2021-04-11T13:26:30Z",
    pushed_at: "2018-02-21T16:07:06Z",
    git_url: "git://github.com/iamshaunjp/CSS-Tips-and-Tricks.git",
    ssh_url: "git@github.com:iamshaunjp/CSS-Tips-and-Tricks.git",
    clone_url: "https://github.com/iamshaunjp/CSS-Tips-and-Tricks.git",
    svn_url: "https://github.com/iamshaunjp/CSS-Tips-and-Tricks",
    homepage: null,
    size: 341,
    stargazers_count: 55,
    watchers_count: 55,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 49,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 3,
    license: null,
    forks: 49,
    open_issues: 3,
    watchers: 55,
    default_branch: "master",
  },
  {
    id: 117077600,
    node_id: "MDEwOlJlcG9zaXRvcnkxMTcwNzc2MDA=",
    name: "CSS-Variables",
    full_name: "iamshaunjp/CSS-Variables",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/CSS-Variables",
    description:
      "Course files for the CSS Variables tutorial playlist on The Net Ninja YouTube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/CSS-Variables",
    forks_url: "https://api.github.com/repos/iamshaunjp/CSS-Variables/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/iamshaunjp/CSS-Variables/teams",
    hooks_url: "https://api.github.com/repos/iamshaunjp/CSS-Variables/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/issues/events{/number}",
    events_url: "https://api.github.com/repos/iamshaunjp/CSS-Variables/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/CSS-Variables/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/iamshaunjp/CSS-Variables/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/CSS-Variables/deployments",
    created_at: "2018-01-11T09:19:13Z",
    updated_at: "2021-01-29T08:11:47Z",
    pushed_at: "2018-01-15T16:49:38Z",
    git_url: "git://github.com/iamshaunjp/CSS-Variables.git",
    ssh_url: "git@github.com:iamshaunjp/CSS-Variables.git",
    clone_url: "https://github.com/iamshaunjp/CSS-Variables.git",
    svn_url: "https://github.com/iamshaunjp/CSS-Variables",
    homepage: null,
    size: 3,
    stargazers_count: 21,
    watchers_count: 21,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 51,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 51,
    open_issues: 0,
    watchers: 21,
    default_branch: "lesson-1",
  },
  {
    id: 147419966,
    node_id: "MDEwOlJlcG9zaXRvcnkxNDc0MTk5NjY=",
    name: "data-ui-with-d3-firebase",
    full_name: "iamshaunjp/data-ui-with-d3-firebase",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/data-ui-with-d3-firebase",
    description:
      "All course files for the Udemy course - Build Data UI's with d3.js & Firebase",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/data-ui-with-d3-firebase/deployments",
    created_at: "2018-09-04T21:11:13Z",
    updated_at: "2021-05-16T05:29:47Z",
    pushed_at: "2019-09-18T13:33:43Z",
    git_url: "git://github.com/iamshaunjp/data-ui-with-d3-firebase.git",
    ssh_url: "git@github.com:iamshaunjp/data-ui-with-d3-firebase.git",
    clone_url: "https://github.com/iamshaunjp/data-ui-with-d3-firebase.git",
    svn_url: "https://github.com/iamshaunjp/data-ui-with-d3-firebase",
    homepage: null,
    size: 47,
    stargazers_count: 140,
    watchers_count: 140,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 122,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 122,
    open_issues: 0,
    watchers: 140,
    default_branch: "master",
  },
  {
    id: 268560503,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjg1NjA1MDM=",
    name: "deno-jumpstart",
    full_name: "iamshaunjp/deno-jumpstart",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/deno-jumpstart",
    description:
      "All course files for the Deno Jumpstart Tutorial on the Net Ninja YouTube chanel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/deno-jumpstart",
    forks_url: "https://api.github.com/repos/iamshaunjp/deno-jumpstart/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/iamshaunjp/deno-jumpstart/teams",
    hooks_url: "https://api.github.com/repos/iamshaunjp/deno-jumpstart/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/issues/events{/number}",
    events_url: "https://api.github.com/repos/iamshaunjp/deno-jumpstart/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/deno-jumpstart/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/iamshaunjp/deno-jumpstart/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/deno-jumpstart/deployments",
    created_at: "2020-06-01T15:30:19Z",
    updated_at: "2021-05-19T08:40:16Z",
    pushed_at: "2020-06-04T10:34:50Z",
    git_url: "git://github.com/iamshaunjp/deno-jumpstart.git",
    ssh_url: "git@github.com:iamshaunjp/deno-jumpstart.git",
    clone_url: "https://github.com/iamshaunjp/deno-jumpstart.git",
    svn_url: "https://github.com/iamshaunjp/deno-jumpstart",
    homepage: null,
    size: 7,
    stargazers_count: 31,
    watchers_count: 31,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 3,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 3,
    open_issues: 0,
    watchers: 31,
    default_branch: "master",
  },
  {
    id: 270031088,
    node_id: "MDEwOlJlcG9zaXRvcnkyNzAwMzEwODg=",
    name: "deno-websockets",
    full_name: "iamshaunjp/deno-websockets",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/deno-websockets",
    description:
      "All course files for the Deno WebSockets (simple chat) course on The Net Ninja YouTube channel",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/deno-websockets",
    forks_url: "https://api.github.com/repos/iamshaunjp/deno-websockets/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/iamshaunjp/deno-websockets/teams",
    hooks_url: "https://api.github.com/repos/iamshaunjp/deno-websockets/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/deno-websockets/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/deno-websockets/deployments",
    created_at: "2020-06-06T16:02:59Z",
    updated_at: "2021-05-20T13:55:20Z",
    pushed_at: "2020-06-08T09:59:37Z",
    git_url: "git://github.com/iamshaunjp/deno-websockets.git",
    ssh_url: "git@github.com:iamshaunjp/deno-websockets.git",
    clone_url: "https://github.com/iamshaunjp/deno-websockets.git",
    svn_url: "https://github.com/iamshaunjp/deno-websockets",
    homepage: null,
    size: 6,
    stargazers_count: 36,
    watchers_count: 36,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 3,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 3,
    open_issues: 0,
    watchers: 36,
    default_branch: "master",
  },
  {
    id: 107942267,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDc5NDIyNjc=",
    name: "django-playlist",
    full_name: "iamshaunjp/django-playlist",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/django-playlist",
    description: "Course files for The Net Ninja Django playlist on YouTube",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/django-playlist",
    forks_url: "https://api.github.com/repos/iamshaunjp/django-playlist/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/iamshaunjp/django-playlist/teams",
    hooks_url: "https://api.github.com/repos/iamshaunjp/django-playlist/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/django-playlist/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/django-playlist/deployments",
    created_at: "2017-10-23T06:43:54Z",
    updated_at: "2021-05-14T17:00:17Z",
    pushed_at: "2020-09-16T06:10:03Z",
    git_url: "git://github.com/iamshaunjp/django-playlist.git",
    ssh_url: "git@github.com:iamshaunjp/django-playlist.git",
    clone_url: "https://github.com/iamshaunjp/django-playlist.git",
    svn_url: "https://github.com/iamshaunjp/django-playlist",
    homepage: null,
    size: 2947,
    stargazers_count: 142,
    watchers_count: 142,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 164,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 11,
    license: null,
    forks: 164,
    open_issues: 11,
    watchers: 142,
    default_branch: "master",
  },
  {
    id: 159351367,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTkzNTEzNjc=",
    name: "firebase-auth",
    full_name: "iamshaunjp/firebase-auth",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/firebase-auth",
    description:
      "All course files for the Firebase authentication tutorial series on The Net Ninja YouTube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/firebase-auth",
    forks_url: "https://api.github.com/repos/iamshaunjp/firebase-auth/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/iamshaunjp/firebase-auth/teams",
    hooks_url: "https://api.github.com/repos/iamshaunjp/firebase-auth/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/issues/events{/number}",
    events_url: "https://api.github.com/repos/iamshaunjp/firebase-auth/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/firebase-auth/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/iamshaunjp/firebase-auth/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/firebase-auth/deployments",
    created_at: "2018-11-27T14:50:12Z",
    updated_at: "2021-05-18T11:40:05Z",
    pushed_at: "2021-04-30T15:02:56Z",
    git_url: "git://github.com/iamshaunjp/firebase-auth.git",
    ssh_url: "git@github.com:iamshaunjp/firebase-auth.git",
    clone_url: "https://github.com/iamshaunjp/firebase-auth.git",
    svn_url: "https://github.com/iamshaunjp/firebase-auth",
    homepage: null,
    size: 60,
    stargazers_count: 273,
    watchers_count: 273,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 304,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 13,
    license: null,
    forks: 304,
    open_issues: 13,
    watchers: 273,
    default_branch: "master",
  },
  {
    id: 134393515,
    node_id: "MDEwOlJlcG9zaXRvcnkxMzQzOTM1MTU=",
    name: "firebase-firestore-playlist",
    full_name: "iamshaunjp/firebase-firestore-playlist",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/firebase-firestore-playlist",
    description:
      "All course files for the Firebase Firestore playlist on The Net Ninja YouTube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/firebase-firestore-playlist/deployments",
    created_at: "2018-05-22T09:40:26Z",
    updated_at: "2021-05-17T04:15:13Z",
    pushed_at: "2021-01-30T16:31:28Z",
    git_url: "git://github.com/iamshaunjp/firebase-firestore-playlist.git",
    ssh_url: "git@github.com:iamshaunjp/firebase-firestore-playlist.git",
    clone_url: "https://github.com/iamshaunjp/firebase-firestore-playlist.git",
    svn_url: "https://github.com/iamshaunjp/firebase-firestore-playlist",
    homepage: null,
    size: 8,
    stargazers_count: 234,
    watchers_count: 234,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 265,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 7,
    license: null,
    forks: 265,
    open_issues: 7,
    watchers: 234,
    default_branch: "master",
  },
  {
    id: 235840422,
    node_id: "MDEwOlJlcG9zaXRvcnkyMzU4NDA0MjI=",
    name: "firebase-functions",
    full_name: "iamshaunjp/firebase-functions",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/firebase-functions",
    description:
      "Course files for the Firebase Cloud Functions tutorial series on The Net Ninja YouTube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/firebase-functions",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/firebase-functions/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/firebase-functions/deployments",
    created_at: "2020-01-23T16:48:52Z",
    updated_at: "2021-05-04T12:54:04Z",
    pushed_at: "2020-01-24T16:59:35Z",
    git_url: "git://github.com/iamshaunjp/firebase-functions.git",
    ssh_url: "git@github.com:iamshaunjp/firebase-functions.git",
    clone_url: "https://github.com/iamshaunjp/firebase-functions.git",
    svn_url: "https://github.com/iamshaunjp/firebase-functions",
    homepage: null,
    size: 56,
    stargazers_count: 99,
    watchers_count: 99,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 62,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 62,
    open_issues: 0,
    watchers: 99,
    default_branch: "master",
  },
  {
    id: 281920095,
    node_id: "MDEwOlJlcG9zaXRvcnkyODE5MjAwOTU=",
    name: "firegram",
    full_name: "iamshaunjp/firegram",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/firegram",
    description:
      "Starting & final course files for the FireGram tutorial (React, Firebase & Framer Motion) on Brad Traversy's YouTube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/firegram",
    forks_url: "https://api.github.com/repos/iamshaunjp/firegram/forks",
    keys_url: "https://api.github.com/repos/iamshaunjp/firegram/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/firegram/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/iamshaunjp/firegram/teams",
    hooks_url: "https://api.github.com/repos/iamshaunjp/firegram/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/firegram/issues/events{/number}",
    events_url: "https://api.github.com/repos/iamshaunjp/firegram/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/firegram/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/firegram/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/firegram/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/firegram/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/firegram/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/firegram/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/firegram/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/firegram/statuses/{sha}",
    languages_url: "https://api.github.com/repos/iamshaunjp/firegram/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/firegram/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/firegram/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/firegram/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/firegram/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/firegram/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/firegram/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/firegram/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/firegram/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/firegram/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/firegram/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/iamshaunjp/firegram/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/firegram/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/iamshaunjp/firegram/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/firegram/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/firegram/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/firegram/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/firegram/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/firegram/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/firegram/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/firegram/deployments",
    created_at: "2020-07-23T10:22:08Z",
    updated_at: "2021-05-10T15:30:29Z",
    pushed_at: "2020-07-30T12:28:39Z",
    git_url: "git://github.com/iamshaunjp/firegram.git",
    ssh_url: "git@github.com:iamshaunjp/firegram.git",
    clone_url: "https://github.com/iamshaunjp/firegram.git",
    svn_url: "https://github.com/iamshaunjp/firegram",
    homepage: null,
    size: 217,
    stargazers_count: 191,
    watchers_count: 191,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 137,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 7,
    license: null,
    forks: 137,
    open_issues: 7,
    watchers: 191,
    default_branch: "master",
  },
  {
    id: 304901381,
    node_id: "MDEwOlJlcG9zaXRvcnkzMDQ5MDEzODE=",
    name: "firestore-pagination-tutorial",
    full_name: "iamshaunjp/firestore-pagination-tutorial",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/firestore-pagination-tutorial",
    description:
      "All the files for the Firestore Pagination tutorial on the Net Ninja YouTube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/firestore-pagination-tutorial/deployments",
    created_at: "2020-10-17T14:53:54Z",
    updated_at: "2021-01-16T09:45:24Z",
    pushed_at: "2020-10-18T12:09:38Z",
    git_url: "git://github.com/iamshaunjp/firestore-pagination-tutorial.git",
    ssh_url: "git@github.com:iamshaunjp/firestore-pagination-tutorial.git",
    clone_url:
      "https://github.com/iamshaunjp/firestore-pagination-tutorial.git",
    svn_url: "https://github.com/iamshaunjp/firestore-pagination-tutorial",
    homepage: null,
    size: 3,
    stargazers_count: 15,
    watchers_count: 15,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 11,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 11,
    open_issues: 0,
    watchers: 15,
    default_branch: "main",
  },
  {
    id: 275798004,
    node_id: "MDEwOlJlcG9zaXRvcnkyNzU3OTgwMDQ=",
    name: "flutter-animations",
    full_name: "iamshaunjp/flutter-animations",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/flutter-animations",
    description:
      "All coursefiles for the Flutter Animations tutorial series on the Net Ninja youtube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/flutter-animations",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/flutter-animations/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/flutter-animations/deployments",
    created_at: "2020-06-29T11:45:22Z",
    updated_at: "2021-05-20T04:52:15Z",
    pushed_at: "2020-06-30T16:09:10Z",
    git_url: "git://github.com/iamshaunjp/flutter-animations.git",
    ssh_url: "git@github.com:iamshaunjp/flutter-animations.git",
    clone_url: "https://github.com/iamshaunjp/flutter-animations.git",
    svn_url: "https://github.com/iamshaunjp/flutter-animations",
    homepage: null,
    size: 455,
    stargazers_count: 57,
    watchers_count: 57,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 38,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    forks: 38,
    open_issues: 1,
    watchers: 57,
    default_branch: "master",
  },
  {
    id: 202311968,
    node_id: "MDEwOlJlcG9zaXRvcnkyMDIzMTE5Njg=",
    name: "flutter-beginners-tutorial",
    full_name: "iamshaunjp/flutter-beginners-tutorial",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/flutter-beginners-tutorial",
    description:
      "All course files for the Flutter Beginners playlist on The Net Ninja YouTube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial",
    forks_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/teams",
    hooks_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/flutter-beginners-tutorial/deployments",
    created_at: "2019-08-14T08:51:52Z",
    updated_at: "2021-05-20T14:41:43Z",
    pushed_at: "2021-04-14T16:44:37Z",
    git_url: "git://github.com/iamshaunjp/flutter-beginners-tutorial.git",
    ssh_url: "git@github.com:iamshaunjp/flutter-beginners-tutorial.git",
    clone_url: "https://github.com/iamshaunjp/flutter-beginners-tutorial.git",
    svn_url: "https://github.com/iamshaunjp/flutter-beginners-tutorial",
    homepage: null,
    size: 9145,
    stargazers_count: 901,
    watchers_count: 901,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 660,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 28,
    license: null,
    forks: 660,
    open_issues: 28,
    watchers: 901,
    default_branch: "master",
  },
  {
    id: 209400064,
    node_id: "MDEwOlJlcG9zaXRvcnkyMDk0MDAwNjQ=",
    name: "flutter-firebase",
    full_name: "iamshaunjp/flutter-firebase",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/flutter-firebase",
    description:
      "All course files for the Flutter & Firebase tutorial playlist on The Net Ninja YouTube channel",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/flutter-firebase",
    forks_url: "https://api.github.com/repos/iamshaunjp/flutter-firebase/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/iamshaunjp/flutter-firebase/teams",
    hooks_url: "https://api.github.com/repos/iamshaunjp/flutter-firebase/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/flutter-firebase/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/flutter-firebase/deployments",
    created_at: "2019-09-18T20:39:50Z",
    updated_at: "2021-05-20T07:57:50Z",
    pushed_at: "2021-04-11T20:50:05Z",
    git_url: "git://github.com/iamshaunjp/flutter-firebase.git",
    ssh_url: "git@github.com:iamshaunjp/flutter-firebase.git",
    clone_url: "https://github.com/iamshaunjp/flutter-firebase.git",
    svn_url: "https://github.com/iamshaunjp/flutter-firebase",
    homepage: null,
    size: 713,
    stargazers_count: 404,
    watchers_count: 404,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 325,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 22,
    license: null,
    forks: 325,
    open_issues: 22,
    watchers: 404,
    default_branch: "master",
  },
  {
    id: 252965310,
    node_id: "MDEwOlJlcG9zaXRvcnkyNTI5NjUzMTA=",
    name: "framer-motion",
    full_name: "iamshaunjp/framer-motion",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/framer-motion",
    description:
      "All course files for the Framer Motion & React tutorial series on The Net Ninja YouTube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/framer-motion",
    forks_url: "https://api.github.com/repos/iamshaunjp/framer-motion/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/iamshaunjp/framer-motion/teams",
    hooks_url: "https://api.github.com/repos/iamshaunjp/framer-motion/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/issues/events{/number}",
    events_url: "https://api.github.com/repos/iamshaunjp/framer-motion/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/framer-motion/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/iamshaunjp/framer-motion/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/framer-motion/deployments",
    created_at: "2020-04-04T10:16:39Z",
    updated_at: "2021-05-13T01:53:41Z",
    pushed_at: "2021-04-19T11:19:10Z",
    git_url: "git://github.com/iamshaunjp/framer-motion.git",
    ssh_url: "git@github.com:iamshaunjp/framer-motion.git",
    clone_url: "https://github.com/iamshaunjp/framer-motion.git",
    svn_url: "https://github.com/iamshaunjp/framer-motion",
    homepage: null,
    size: 331,
    stargazers_count: 130,
    watchers_count: 130,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 92,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 5,
    license: null,
    forks: 92,
    open_issues: 5,
    watchers: 130,
    default_branch: "master",
  },
  {
    id: 334180135,
    node_id: "MDEwOlJlcG9zaXRvcnkzMzQxODAxMzU=",
    name: "gatsby-tutorial",
    full_name: "iamshaunjp/gatsby-tutorial",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/gatsby-tutorial",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/gatsby-tutorial",
    forks_url: "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/teams",
    hooks_url: "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/gatsby-tutorial/deployments",
    created_at: "2021-01-29T15:11:14Z",
    updated_at: "2021-05-19T07:53:19Z",
    pushed_at: "2021-03-14T00:40:40Z",
    git_url: "git://github.com/iamshaunjp/gatsby-tutorial.git",
    ssh_url: "git@github.com:iamshaunjp/gatsby-tutorial.git",
    clone_url: "https://github.com/iamshaunjp/gatsby-tutorial.git",
    svn_url: "https://github.com/iamshaunjp/gatsby-tutorial",
    homepage: null,
    size: 6549,
    stargazers_count: 40,
    watchers_count: 40,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 69,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 4,
    license: {
      key: "0bsd",
      name: "BSD Zero Clause License",
      spdx_id: "0BSD",
      url: "https://api.github.com/licenses/0bsd",
      node_id: "MDc6TGljZW5zZTM1",
    },
    forks: 69,
    open_issues: 4,
    watchers: 40,
    default_branch: "main",
  },
  {
    id: 92412995,
    node_id: "MDEwOlJlcG9zaXRvcnk5MjQxMjk5NQ==",
    name: "git-playlist",
    full_name: "iamshaunjp/git-playlist",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/git-playlist",
    description:
      "Playground for the Net Ninja Git / GitHub tutorials on YouTube",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/git-playlist",
    forks_url: "https://api.github.com/repos/iamshaunjp/git-playlist/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/iamshaunjp/git-playlist/teams",
    hooks_url: "https://api.github.com/repos/iamshaunjp/git-playlist/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/issues/events{/number}",
    events_url: "https://api.github.com/repos/iamshaunjp/git-playlist/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/git-playlist/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/iamshaunjp/git-playlist/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/git-playlist/deployments",
    created_at: "2017-05-25T14:43:31Z",
    updated_at: "2021-04-19T04:17:14Z",
    pushed_at: "2021-05-19T13:14:57Z",
    git_url: "git://github.com/iamshaunjp/git-playlist.git",
    ssh_url: "git@github.com:iamshaunjp/git-playlist.git",
    clone_url: "https://github.com/iamshaunjp/git-playlist.git",
    svn_url: "https://github.com/iamshaunjp/git-playlist",
    homepage: null,
    size: 408,
    stargazers_count: 102,
    watchers_count: 102,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 344,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 273,
    license: null,
    forks: 344,
    open_issues: 273,
    watchers: 102,
    default_branch: "master",
  },
  {
    id: 366638516,
    node_id: "MDEwOlJlcG9zaXRvcnkzNjY2Mzg1MTY=",
    name: "golang-tutorials",
    full_name: "iamshaunjp/golang-tutorials",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/golang-tutorials",
    description: "All course files for the Net Ninja Go tutorial series.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/golang-tutorials",
    forks_url: "https://api.github.com/repos/iamshaunjp/golang-tutorials/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/iamshaunjp/golang-tutorials/teams",
    hooks_url: "https://api.github.com/repos/iamshaunjp/golang-tutorials/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/golang-tutorials/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/golang-tutorials/deployments",
    created_at: "2021-05-12T08:02:10Z",
    updated_at: "2021-05-20T15:59:42Z",
    pushed_at: "2021-05-19T05:58:25Z",
    git_url: "git://github.com/iamshaunjp/golang-tutorials.git",
    ssh_url: "git@github.com:iamshaunjp/golang-tutorials.git",
    clone_url: "https://github.com/iamshaunjp/golang-tutorials.git",
    svn_url: "https://github.com/iamshaunjp/golang-tutorials",
    homepage: null,
    size: 28,
    stargazers_count: 33,
    watchers_count: 33,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 1,
    open_issues: 0,
    watchers: 33,
    default_branch: "main",
  },
  {
    id: 123586311,
    node_id: "MDEwOlJlcG9zaXRvcnkxMjM1ODYzMTE=",
    name: "graphql-playlist",
    full_name: "iamshaunjp/graphql-playlist",
    private: false,
    owner: {
      login: "iamshaunjp",
      id: 9838872,
      node_id: "MDQ6VXNlcjk4Mzg4NzI=",
      avatar_url: "https://avatars.githubusercontent.com/u/9838872?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/iamshaunjp",
      html_url: "https://github.com/iamshaunjp",
      followers_url: "https://api.github.com/users/iamshaunjp/followers",
      following_url:
        "https://api.github.com/users/iamshaunjp/following{/other_user}",
      gists_url: "https://api.github.com/users/iamshaunjp/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/iamshaunjp/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/iamshaunjp/subscriptions",
      organizations_url: "https://api.github.com/users/iamshaunjp/orgs",
      repos_url: "https://api.github.com/users/iamshaunjp/repos",
      events_url: "https://api.github.com/users/iamshaunjp/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/iamshaunjp/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/iamshaunjp/graphql-playlist",
    description:
      "All course files for the GraphQL tutorial playlist on The Net Ninja YouTube channel.",
    fork: false,
    url: "https://api.github.com/repos/iamshaunjp/graphql-playlist",
    forks_url: "https://api.github.com/repos/iamshaunjp/graphql-playlist/forks",
    keys_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/iamshaunjp/graphql-playlist/teams",
    hooks_url: "https://api.github.com/repos/iamshaunjp/graphql-playlist/hooks",
    issue_events_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/events",
    assignees_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/branches{/branch}",
    tags_url: "https://api.github.com/repos/iamshaunjp/graphql-playlist/tags",
    blobs_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/languages",
    stargazers_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/stargazers",
    contributors_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/contributors",
    subscribers_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/subscribers",
    subscription_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/subscription",
    commits_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/merges",
    archive_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/downloads",
    issues_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/labels{/name}",
    releases_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/iamshaunjp/graphql-playlist/deployments",
    created_at: "2018-03-02T14:04:28Z",
    updated_at: "2021-05-18T16:45:42Z",
    pushed_at: "2021-04-14T02:43:44Z",
    git_url: "git://github.com/iamshaunjp/graphql-playlist.git",
    ssh_url: "git@github.com:iamshaunjp/graphql-playlist.git",
    clone_url: "https://github.com/iamshaunjp/graphql-playlist.git",
    svn_url: "https://github.com/iamshaunjp/graphql-playlist",
    homepage: null,
    size: 146,
    stargazers_count: 595,
    watchers_count: 595,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 489,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 13,
    license: null,
    forks: 489,
    open_issues: 13,
    watchers: 595,
    default_branch: "master",
  },
];

export default mockRepos;
